/** Labels describe the existing card approval, not an unavailable full script. */
export const contentReviewCopy = {
  en: {
    step: 'Idea & script · Content review',
    scope:
      'Review the prepared content summary below. A full timed script is not available in this view.',
    prepared: 'Prepared content',
    format: 'Production details',
    approval:
      'Approving this Content Card starts production using this version. It is not approval of a full timed script.',
    approve: 'Approve content & start production',
  },
  ar: {
    step: 'الفكرة والنص · مراجعة المحتوى',
    scope:
      'راجع ملخص المحتوى المحضّر أدناه. النص الكامل بتوقيت المشاهد غير متاح في هذا العرض.',
    prepared: 'المحتوى المحضّر',
    format: 'تفاصيل الإنتاج',
    approval:
      'اعتماد بطاقة المحتوى هذه يبدأ الإنتاج باستخدام هذه النسخة. هذا ليس اعتماداً لنص كامل بتوقيت المشاهد.',
    approve: 'اعتماد المحتوى وبدء الإنتاج',
  },
} as const;
